module.exports = __webpack_public_path__ + "img/mini-019.2e006628.jpg";